import * as Inventory from 'src/replicant/inventory';
import StateObserver from 'src/StateObserver';

export function getDisplayedBPoints() {
  const { user, inventory } = StateObserver.getState();
  return Inventory.getters.getPoints(user) - inventory.compensation.bPoints;
}

export function getDisplayedGems() {
  const { user, inventory } = StateObserver.getState();
  return Inventory.getters.getGems(user) - inventory.compensation.gems;
}

export function getDisplayedEnergy() {
  const { user, inventory } = StateObserver.getState();
  return (
    Inventory.getters.getEnergy(user, StateObserver.now()) -
    inventory.compensation.energy
  );
}

export function getDisplayedStars() {
  const { user, inventory } = StateObserver.getState();
  return Inventory.getters.getStars(user) - inventory.compensation.stars;
}
